import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nProvider } from './i18n/index.tsx';
import { ThemeProvider } from './theme/index.tsx';
import { ExpertModeProvider } from './expert/index.tsx';
import { App } from './App.tsx';
import './theme/theme.css';
import './app.css';

const container = document.getElementById('root');
if (!container) throw new Error('No #root element to mount into');

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <I18nProvider>
        <ExpertModeProvider>
          <App />
        </ExpertModeProvider>
      </I18nProvider>
    </ThemeProvider>
  </StrictMode>,
);
